import React from "react";
import { Map } from "immutable";

import Boolean from "./DataTypes/Boolean";
import False from "./DataTypes/Boolean/False";
import True from "./DataTypes/Boolean/True";
import Date from "./DataTypes/Date";
import DateTime from "./DataTypes/DateTime";
import Number from "./DataTypes/Number";
import Float from "./DataTypes/Number/Float";
import Integer from "./DataTypes/Number/Integer";
import Time from "./DataTypes/Time";
import Text from "./DataTypes/Text";
import URL from "./DataTypes/Text/URL";
import Class from "./Class";

const propertiesByType = Map({
  Boolean,
  False,
  True,
  Date,
  DateTime,
  Number,
  Float,
  Integer,
  Time,
  Text,
  URL
});

const withValueState = Component =>
  class extends React.Component {
    constructor(props) {
      super(props);

      this.handleChange = this.handleChange.bind(this);

      this.state = {
        value: props.propertyValue.value
      };
    }
    handleChange(e) {
      this.setState({
        value: e.target.value
      });
    }
    render() {
      return (
        <Component
          {...this.props}
          value={this.state.value}
          onChange={this.handleChange}
        />
      );
    }
  };

/**
 * Create a Property Instance component.
 *
 * @since 1.0.0
 * @constructor
 */
const PropertyInstanceFactory = class extends React.Component {
  constructor(props) {
    super(props);

    this.Component = withValueState(
      propertiesByType.get(
        // Look up the property by type.
        props.propertyValue.type,
        // Default if by type isn't found.
        Class
      )
    );
  }

  render() {
    // Splat the `property{name, type, value}` and the `props` provided at render time.
    // Warning: changing the order below may break the `defaultValue/value` property.
    return <this.Component {...this.props} />;
  }
};

// Finally export the PropertyInstanceFactory.
export default PropertyInstanceFactory;
